import { render, staticRenderFns } from "./subscribe-header.vue?vue&type=template&id=1b05010f&lang=pug&"
import script from "./subscribe-header.vue?vue&type=script&lang=js&"
export * from "./subscribe-header.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports